import React from "react";
import Card from "react-bootstrap/Card";
import { VscDebugBreakpointDataUnverified } from "react-icons/vsc";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am a student of <span className="purple"><b> Bachelor In Computer Science </b></span>
            from <span className="purple"> <b> Comsats University, Lahore. </b> </span>
            {/* <br />I am a junior pursuing IMSC in Maths and Computing in BIT
            Mesra. */}
            <br />
            <br />
            <b>
              Some Curricular activities other than programming..

            </b>
          </p>
          <ul>
            <li className="about-activity">
              <VscDebugBreakpointDataUnverified /> FOOTBALL
            </li>
            <li className="about-activity">
              <VscDebugBreakpointDataUnverified /> PUBG
            </li>
            <li className="about-activity">
              <VscDebugBreakpointDataUnverified /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Experience is the name everyone gives to their mistakes!"
          </p>
          <p className="purple">~Oscar Wilde</p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
